"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const SidebarTracking_vue_1 = __importDefault(require("../Layout/SidebarTracking.vue"));
const ProposalDetailYield_vue_1 = __importDefault(require("./Detail/ProposalDetailYield.vue"));
const ResetGISModal_vue_1 = __importDefault(require("./Detail/ResetGISModal.vue"));
const AreaPlaygroundYield_vue_1 = __importDefault(require("./Playground/AreaPlaygroundYield.vue"));
const ProposalListYield_vue_1 = __importDefault(require("./List/ProposalListYield.vue"));
const TopbarTracking_vue_1 = __importDefault(require("../Layout/TopbarTracking.vue"));
const ModalChangeModule_vue_1 = __importDefault(require("@becrop/components/Modules/Common/Components/ModalChangeModule.vue"));
const axios_1 = __importDefault(require("axios"));
const User_1 = __importDefault(require("@common/models/User"));
const Proposal_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Proposal"));
const Module_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Module"));
const SamplingPoint_1 = __importDefault(require("@becrop/components/Modules/Common/Models/SamplingPoint"));
const GISArea_1 = __importDefault(require("@becrop/components/Modules/Common/Models/GISArea"));
const ModuleChangePayload_1 = __importDefault(require("@becrop/components/Modules/Common/Models/ModuleChangePayload"));
const trans_1 = require("@common/tsutils/trans");
const moment_1 = __importDefault(require("moment"));
const SubclientsSwitcher_vue_1 = __importDefault(require("@becrop/components/Common/SubclientsSwitcher.vue"));
let ProposalsView = class ProposalsView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.raw_user = null;
        this.user = null;
        this.viewMode = 'list'; // 'list', 'detail', 'playground'
        this.sidebar_selected = 'proposals';
        this.itemsPerPageClient = 10;
        // per_page
        this.itemsPerPageServer = 50;
        // totalItems = 210;
        this.totalItems = 0;
        this.currentPage = 1;
        this.playgroundMode = 'drag';
        this.hasMapTabs = true;
        this.fetchedPagedProposals = [];
        this.moduleController = new Module_1.default({});
        this.fetchedDetails = [];
        this.rawProposals = [];
        this.currentProposals = {
            page: 0,
            proposals: [],
        };
        this.downloadedProposals = [];
        this.proposal = new Proposal_1.default({});
        this.areas = [];
        this.currentArea = {};
        this.statusParam = '';
        this.loadingData = false;
        this.loadingView = false;
        this.isDeployChangeModule = false;
        this.moduleChangePayload = new ModuleChangePayload_1.default({});
        this.samplingStepStatus = 'default';
        this.result = { success: false, message: '' };
        this.isLoading = false;
        this.isResetGISModalVisible = false;
        this.proposalId = null;
        this.projectId = null;
        this.proposalSelect = null;
        /*     async loadProposalDetailFn(proposalId: number, projectId: number) {
                console.log('load detail ' + proposalId + ' ' + projectId);
                const urlParams = new URLSearchParams(window.location.search);
        
                this.loadingView = true;
                const myProposal = await this.fetchDetails(proposalId);
                if (myProposal) this.proposal = new Proposal(myProposal);
                this.projectId = this.proposal.deliverables[0].project_id;
        
                this.isTableTrials(this.proposal);
                this.loadingView = false;
                const crumbParam = urlParams.get('proposal') || '';
        
                if (crumbParam.length === 0) {
                    const url = new URL(window.location.href.split('?')[0]);
                    url.searchParams.set('proposal', proposalId.toString());
                    window.history.pushState({}, '', url);
                }
        
                this.viewMode = 'detail';
            } */
        this.hasTableTrials = false;
        this.toastSubclient = false;
        this.modeResetGISModal = 'ask';
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    /*

    */
    get isBMK() {
        return this.raw_user.is_bmk && this.raw_user.role == 1;
    }
    get canUploadTracking() {
        return this.raw_user.it_level === 1 || this.raw_user.is_bmk;
    }
    get currentProposalItems() {
        if (this.totalItems > 0) {
            return this.currentProposals.proposals;
        }
        else {
            return [];
        }
    }
    isVisibleToast() {
        if (this.toastSubclient)
            return true;
        return false;
    }
    setPhaseAsDone(phaseSlug, areaID) {
        this.proposal.deliverables.forEach((d) => {
            d.areas.forEach((a) => {
                if (a.meta.id === areaID) {
                    if (phaseSlug === 'gis_file_upload') {
                        a.status.name = (0, trans_1.trans)('tracking.life_cycles.calculating_zones.title_min');
                        a.status.phase = 'bmk';
                        a.status.slug = 'calculating_zones';
                        a.life_cycle_area.forEach((lf) => {
                            if (lf.slug === 'calculating_zones') {
                                lf.status = 'pending';
                                lf.completed_at = null;
                            }
                        });
                    }
                    if (phaseSlug === 'sample_collecting') {
                        a.status.name = (0, trans_1.trans)('tracking.life_cycles.sample_shipping.title_min');
                        a.status.phase = 'user';
                        a.status.slug = 'sample_shipping';
                        a.life_cycle_area.forEach((lf) => {
                            if (lf.slug === 'sample_shipping') {
                                lf.status = 'pending';
                                lf.completed_at = null;
                            }
                        });
                    }
                    if (phaseSlug === 'sample_shipping') {
                        a.status.name = (0, trans_1.trans)('tracking.life_cycles.laboratory.title_min');
                        a.status.phase = 'bmk';
                        a.status.slug = 'lab_received';
                        a.life_cycle_area.forEach((lf) => {
                            if (lf.slug === 'lab_received') {
                                lf.status = 'pending';
                                lf.completed_at = null;
                            }
                        });
                    }
                    a.life_cycle_area.forEach((lf) => {
                        if (lf.slug === phaseSlug) {
                            lf.status = 'on_track';
                            lf.completed_at = (0, moment_1.default)().format('YYYY-MM-DD');
                        }
                    });
                }
            });
        });
        if (phaseSlug === 'gis_file_upload') {
            let phasePropChange = true;
            this.proposal.deliverables.forEach((d) => {
                if (d.areas.some((a) => a.status.slug === 'gis_file_upload')) {
                    phasePropChange = false;
                }
            });
            if (phasePropChange) {
                const newStatus = {
                    slug: 'calculating_zones',
                    name: (0, trans_1.trans)('tracking.life_cycles.calculating_zones.title_min'),
                    phase: 'bmk',
                };
                this.proposal.status = newStatus;
                const myCurrentProp = this.currentProposals.proposals.find((p) => p.id === this.proposal.id);
                myCurrentProp.status = newStatus;
            }
        }
        if (phaseSlug === 'sample_collecting') {
            let phasePropChange = true;
            this.proposal.deliverables.forEach((d) => {
                if (d.areas.some((a) => a.status.slug === 'sample_collecting')) {
                    phasePropChange = false;
                }
            });
            if (phasePropChange) {
                const newStatus = {
                    slug: 'sample_shipping',
                    name: (0, trans_1.trans)('tracking.life_cycles.sample_shipping.title_min'),
                    phase: 'user',
                };
                this.proposal.status = newStatus;
                const myCurrentProp = this.currentProposals.proposals.find((p) => p.id === this.proposal.id);
                myCurrentProp.status = newStatus;
            }
        }
        if (phaseSlug === 'sample_shipping') {
            let phasePropChange = true;
            this.proposal.deliverables.forEach((d) => {
                if (d.areas.some((a) => a.status.slug === 'sample_shipping')) {
                    phasePropChange = false;
                }
            });
            if (phasePropChange) {
                const newStatus = {
                    slug: 'lab_received',
                    name: (0, trans_1.trans)('tracking.life_cycles.laboratory.title_min'),
                    phase: 'bmk',
                };
                this.proposal.status = newStatus;
                const myCurrentProp = this.currentProposals.proposals.find((p) => p.id === this.proposal.id);
                myCurrentProp.status = newStatus;
            }
        }
        this.viewMode = 'detail';
    }
    updateSortableProposals(c, d) {
        function fixNullsValue(val) {
            let temp = val;
            if (!val)
                temp = '---';
            return temp;
        }
        function getMyKey(criteria) {
            if (criteria === 'name')
                return 'name';
            if (criteria === 'accepted_at')
                return 'accepted_at';
            if (criteria === 'deliverables')
                return 'deliverables';
            if (criteria === 'status')
                return 'status';
            return 'name';
        }
        const keyToSort = getMyKey(c);
        const allDownloadedProposals = [];
        this.fetchedPagedProposals.forEach((pag) => {
            pag.proposals.forEach((prop) => {
                allDownloadedProposals.push(prop);
            });
        });
        allDownloadedProposals.sort((a, b) => {
            if (keyToSort !== 'status') {
                if (d === -1) {
                    return a[keyToSort] > b[keyToSort] ? -1 : 1;
                }
                if (d === 1) {
                    return a[keyToSort] < b[keyToSort] ? -1 : 1;
                }
            }
            else {
                if (d === -1) {
                    return a.status_number > b.status_number ? -1 : 1;
                }
                if (d === 1) {
                    return a.status_number < b.status_number ? -1 : 1;
                }
            }
        });
        this.fetchedPagedProposals.forEach((pag, i) => {
            pag.proposals = [];
            let initialIx = i * this.itemsPerPageClient;
            let finalIx = (i + 1) * this.itemsPerPageClient;
            pag.proposals = allDownloadedProposals.slice(initialIx, finalIx);
        });
        this.loadPage(1);
    }
    async fetchDetails(id, forceRefresh = false) {
        // Check if already fetched
        const prop = this.fetchedDetails.find((p) => p.id === id);
        let tempProposal = new Proposal_1.default({});
        if (prop && !forceRefresh) {
            this.proposal = prop;
            tempProposal = prop;
        }
        else {
            // Fetch from db
            const baseURL = '/tracking';
            const config = {
                baseURL,
                timeout: 30000,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                },
            };
            axios_1.default.create(config);
            this.loadingData = true;
            try {
                const url = '/proposals/' + id;
                const response = await axios_1.default.get(config.baseURL + url);
                tempProposal = response.data;
                this.fetchedDetails.push(response.data);
                this.loadingView = false;
            }
            catch (e) {
                this.loadingView = false;
                console.log(e.message);
            }
            this.loadingView = false;
            this.loadingData = false;
            // Once fetched -> push it to fetched
            // Oncce fetched -> asign it to proposal
        }
        return tempProposal;
    }
    fetchAreas(id) {
        const areas = this.proposal.deliverables.map((d) => d.areas);
        const areasFlat = areas.flat();
        const uniqueIDs = [];
        const uniqueAreas = [];
        let selectedArea;
        if (areasFlat[0]) {
            selectedArea = areasFlat[0];
        }
        areasFlat.forEach((area) => {
            if (!uniqueIDs.includes(area.meta.id)) {
                uniqueIDs.push(area.meta.id);
                if (area.meta.id !== id) {
                    uniqueAreas.push(area);
                }
                else {
                    selectedArea = area;
                }
            }
        });
        uniqueAreas.unshift(selectedArea);
        this.areas = uniqueAreas;
    }
    loadAreaTab(t) {
        this.currentArea = this.areas[t];
    }
    loadAreaPlaygroundArea(areaid, proposalid, mode) {
        if (mode === 'view') {
            this.fetchAreas(areaid);
            this.viewMode = 'playground';
            this.playgroundMode = 'view';
            this.hasMapTabs = false;
            this.currentArea = this.areas.find((a) => a.meta.id === areaid);
        }
        else {
            this.fetchAreas(areaid);
            this.currentArea = this.areas.find((a) => a.meta.id === areaid);
            this.playgroundMode = 'drag';
            this.viewMode = 'playground';
        }
    }
    loadAreaPlaygroundZones(data, area) {
        this.areas = [];
        this.currentArea = area;
        this.areas = data.hzones.map((hzone, i) => {
            let newAreaHZones = new GISArea_1.default({
                meta: {
                    id: hzone.id,
                    name: 'Zone ' + (i + 1),
                    // num_samples: data.num_samples,
                    crop: {
                        id: 0,
                        name: data.crop.name,
                        logo_name: data.crop.logo_name,
                    },
                    extension: '0',
                    extension_unit: 'ha',
                },
                geodata: hzone.geodata,
                fields: hzone.gis_fields || [],
                status: {
                    slug: '',
                    name: '',
                    phase: '',
                },
                life_cycle_area: [],
                samplingPoints: [],
            });
            newAreaHZones.samplingPoints = hzone.sampling_points.map((point) => {
                let mypoint = new SamplingPoint_1.default({
                    collecting_at: point.collecting_at,
                    geodata: point.geodata,
                    sample_code: point.sample_code,
                    sample_id: point.sample_id,
                    field_name: point.field_name || point.gis_field_name,
                });
                return mypoint;
            });
            return newAreaHZones;
        });
        if (!!this.currentArea) {
            this.currentArea.area.meta.num_points = this.areas.map((area) => area.samplingPoints.length).reduce((a, b) => a + b, 0);
            this.currentArea.area.meta.num_samples = data.num_samples;
        }
        this.playgroundMode = 'mapzones';
        this.hasMapTabs = true;
        this.viewMode = 'playground';
    }
    get clientPagesByServerCall() {
        return Math.ceil(this.itemsPerPageServer / this.itemsPerPageClient);
    }
    get isAllDownload() {
        const numAllDownloaded = this.fetchedPagedProposals.reduce((a, b) => {
            return a + b.proposals.length;
        }, 0);
        if (numAllDownloaded === this.totalItems)
            return true;
        return false;
    }
    async fetchProposalsFromServer(p, s) {
        const baseURL = '';
        const config = {
            baseURL,
            timeout: 30000,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Headers': '*',
            },
        };
        axios_1.default.create(config);
        this.loadingData = true;
        let proposals = [];
        try {
            let url = '/tracking/proposals?page=' + p;
            if (s.length > 0) {
                url = '/tracking/proposals?&search=' + s;
            }
            const response = await axios_1.default.get(config.baseURL + url);
            proposals = Object.values(response.data.data);
            this.itemsPerPageServer = response.data.per_page;
            this.totalItems = response.data.total;
        }
        catch (e) {
            console.log(e.message);
        }
        this.loadingData = false;
        return proposals;
    }
    async loadPageForced(n) {
        this.loadingData = true;
        const clientServerFactor = this.itemsPerPageServer / this.itemsPerPageClient;
        const parseServerPage = Math.ceil(n / clientServerFactor);
        const initialClientPage = (parseServerPage - 1) * clientServerFactor + 1;
        this.rawProposals = await this.fetchProposalsFromServer(parseServerPage, '');
        const newPagedProposals = [];
        if (this.rawProposals) {
            this.rawProposals.forEach((rawP, i) => {
                const myClientPage = initialClientPage + Math.floor(i / this.itemsPerPageClient);
                const ix = Math.floor(i / this.itemsPerPageClient);
                if (newPagedProposals.findIndex((page) => page.page === myClientPage) !==
                    -1) {
                    newPagedProposals[ix].proposals.push(rawP);
                }
                else {
                    const propInit = [];
                    propInit.push(rawP);
                    newPagedProposals[ix] = {
                        page: myClientPage,
                        proposals: propInit,
                    };
                }
            });
            this.fetchedPagedProposals = [
                ...this.fetchedPagedProposals,
                ...newPagedProposals,
            ];
            this.currentProposals = newPagedProposals[n - initialClientPage];
            this.currentPage = n;
            this.loadingData = false;
        }
    }
    async loadPage(n) {
        this.loadingData = true;
        if (this.fetchedPagedProposals.find((p) => p.page === n)) {
            // Load proposals already fetched
            this.currentProposals = this.fetchedPagedProposals[n - 1];
        }
        else {
            await this.loadPageForced(n);
        }
        this.currentPage = n;
        this.loadingData = false;
    }
    async loadProposalDetail(id, forceRefresh = false) {
        var _a;
        if (id) {
            this.proposalId = id;
            this.loadingView = true;
            const myProposal = await this.fetchDetails(id, forceRefresh);
            if (myProposal)
                this.proposal = new Proposal_1.default(myProposal);
            this.loadingView = false;
            this.isTableTrials(myProposal);
            this.proposalId = this.proposal.id;
            this.projectId = (_a = this.proposal.deliverables[0]) === null || _a === void 0 ? void 0 : _a.project_id;
            const urlParams = new URLSearchParams(window.location.search);
            const crumbParam = urlParams.get('proposal') || '';
            if (crumbParam.length === 0) {
                const url = new URL(window.location.href.split('?')[0]);
                url.searchParams.set('proposal', id.toString());
                window.history.pushState({}, '', url);
            }
            this.viewMode = 'detail';
        }
    }
    isTableTrials(proposal) {
        let value = false;
        for (const project of proposal === null || proposal === void 0 ? void 0 : proposal.deliverables) {
            if ((project === null || project === void 0 ? void 0 : project.type) !== 'trials' && (project === null || project === void 0 ? void 0 : project.type) !== 'study') {
                value = false;
            }
            else {
                value = true;
            }
        }
        this.hasTableTrials = value;
        return value;
    }
    async clearAllCachedProposals() {
        this.fetchedPagedProposals = [];
        this.fetchedDetails = [];
        this.rawProposals = [];
        this.currentProposals = {
            page: 0,
            proposals: [],
        };
        this.proposal = new Proposal_1.default({
            name: '',
            code_name: '',
            id: 0,
            accepted_at: '',
            contact: {
                name: '',
                email: '',
            },
            status: {
                slug: '',
                name: '',
                phase: '',
            },
            deliverables: [],
        });
    }
    async loadFilteredProposals(n, s) {
        this.clearAllCachedProposals();
        if (s.length > 0) {
            const clientServerFactor = this.itemsPerPageServer / this.itemsPerPageClient;
            const parseServerPage = Math.ceil(n / clientServerFactor);
            const initialClientPage = (parseServerPage - 1) * clientServerFactor + 1;
            this.rawProposals = await this.fetchProposalsFromServer(1, s);
            const newPagedProposals = [];
            this.rawProposals.forEach((rawP, i) => {
                const myClientPage = initialClientPage + Math.floor(i / this.itemsPerPageClient);
                const ix = Math.floor(i / this.itemsPerPageClient);
                if (newPagedProposals.findIndex((page) => page.page === myClientPage) !==
                    -1) {
                    newPagedProposals[ix].proposals.push(rawP);
                }
                else {
                    const propInit = [];
                    propInit.push(rawP);
                    newPagedProposals[ix] = {
                        page: myClientPage,
                        proposals: propInit,
                    };
                }
            });
            this.fetchedPagedProposals = [
                ...this.fetchedPagedProposals,
                ...newPagedProposals,
            ];
            this.currentProposals = newPagedProposals[n - initialClientPage];
        }
        else {
            this.loadPageForced(1);
            window.history.pushState({}, '', new URL(window.location.href.split('?')[0]));
        }
    }
    switchToResults(payload) {
        this.moduleChangePayload = payload;
        this.isDeployChangeModule = true;
    }
    dismissModalTime() {
        this.isDeployChangeModule = false;
    }
    launchCrumb(c) {
        if (c === 'home') {
            window.location.href = '/tracking/';
        }
        let url;
        if (window.location.href.split('?')[0]) {
            url = new URL(window.location.href.split('?')[0]);
        }
        window.history.pushState({}, '', url);
        this.viewMode = c;
    }
    launchCrumbFromPlayground(c) {
        if (c === 'home') {
            window.location.href = '/tracking/';
        }
        else {
            this.viewMode = c;
        }
    }
    get numPages() {
        return Math.ceil(this.totalItems / this.itemsPerPageClient);
    }
    onMountedList() {
        // 2a. If no params, fetch first batch
        if (this.statusParam.length === 0) {
            if (this.raw_initial_proposals.current_page !== 0) {
                this.currentProposals.page = this.raw_initial_proposals.current_page;
                this.currentProposals.proposals = this.raw_initial_proposals.data;
                this.rawProposals = this.raw_initial_proposals.data;
                const clientServerFactor = this.itemsPerPageServer / this.itemsPerPageClient;
                const parseServerPage = Math.ceil(1 / clientServerFactor);
                const initialClientPage = (parseServerPage - 1) * clientServerFactor + 1;
                const newPagedProposals = [];
                this.rawProposals.forEach((rawP, i) => {
                    const myClientPage = initialClientPage + Math.floor(i / this.itemsPerPageClient);
                    const ix = Math.floor(i / this.itemsPerPageClient);
                    if (newPagedProposals.findIndex((page) => page.page === myClientPage) !== -1) {
                        newPagedProposals[ix].proposals.push(rawP);
                    }
                    else {
                        const propInit = [];
                        propInit.push(rawP);
                        newPagedProposals[ix] = {
                            page: myClientPage,
                            proposals: propInit,
                        };
                    }
                });
                this.fetchedPagedProposals = [
                    ...this.fetchedPagedProposals,
                    ...newPagedProposals,
                ];
                if (newPagedProposals[0]) {
                    this.currentProposals = newPagedProposals[0];
                }
            }
        }
        else {
            this.loadFilteredProposals(1, this.statusParam);
        }
        this.totalItems = this.raw_initial_proposals.total;
    }
    getURLParams() {
        const urlParams = new URLSearchParams(window.location.search);
        this.statusParam = urlParams.get('status') || '';
    }
    mounted() {
        // 2. Check paramss
        this.getURLParams();
        this.onMountedList();
        const urlParams = new URLSearchParams(window.location.search);
        const crumbParam = urlParams.get('proposal') || '';
        if (urlParams.get('proposal')) {
            this.loadProposalDetail(parseInt(urlParams.get('proposal')));
        }
    }
    loadView(u) {
        switch (u) {
            case 'home':
                this.sidebar_selected = 'home';
                window.location.href = '/tracking/';
                break;
            case 'proposals':
                this.sidebar_selected = 'proposals';
                window.location.href = '/tracking/proposalslist';
                break;
            default:
                this.sidebar_selected = 'home';
                window.location.href = '/tracking/';
                break;
        }
    }
    async created() {
        this.toastSubclient = false;
        const isSubclientChange = localStorage.getItem('is_subclient_change');
        const value = JSON.parse(isSubclientChange);
        if (value === true) {
            this.toastSubclient = true;
            await setTimeout(() => {
                this.toastSubclient = false;
            }, 10000);
            localStorage.setItem('is_subclient_change', JSON.stringify(false));
        }
        // 1. Get user
        if (this.raw_user)
            this.user = User_1.default.fromJson(this.raw_user);
        if (this.raw_initial_proposals.current_page !== 0) {
            this.totalItems = this.raw_initial_proposals.total;
            this.currentProposals = {
                page: this.raw_initial_proposals.current_page,
                proposals: this.raw_initial_proposals.data,
            };
            this.fetchedPagedProposals.push(this.currentProposals);
        }
    }
    localStorageSubclient(subclientChange) {
        var _a;
        localStorage.setItem('is_subclient_change', JSON.stringify(true));
        localStorage.setItem('subclient_change', JSON.stringify((_a = subclientChange.sub_client) === null || _a === void 0 ? void 0 : _a.nombre_comercial));
    }
    onChangeSamplingStepStatus(status) {
        this.samplingStepStatus = status;
    }
    showResetGISModal() {
        this.isResetGISModalVisible = true;
    }
    hideResetGISModal() {
        this.isResetGISModalVisible = false;
    }
    onResetGisArea(gisAreaId, proposalId) {
        this.modeResetGISModal = 'ask';
        this.currentGisAreaId = gisAreaId;
        this.currentProposalId = proposalId;
        this.showResetGISModal();
    }
    resetGisArea(gisAreaId, proposalId) {
        if (this.isLoading) {
            return;
        }
        this.isLoading = true;
        const data = {};
        axios_1.default.post(`/tracking/gis_area/${gisAreaId}/reset`, data)
            .then(response => {
            const data = response.data;
            this.result.success = (data.type === 'success');
            this.result.message = data.message;
            if (this.result.success) {
                this.loadProposalDetail(this.proposalId, true);
            }
            console.log('GIS has been successfully reset', response.data);
        })
            .catch((error) => {
            var _a, _b;
            const errorMessage = ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || error.message || 'An error occurred';
            this.result.success = false;
            this.result.message = errorMessage;
            console.error('Failed to reset GIS:', error, errorMessage); // Log detailed error info
        })
            .finally(() => {
            this.modeResetGISModal = 'result';
            this.isLoading = false;
        });
    }
    get subclientChange() {
        const isSubclientChange = localStorage.getItem('subclient_change');
        return isSubclientChange;
    }
    changeMapTabsVisibility(visibility) {
        this.hasMapTabs = visibility;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ProposalsView.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProposalsView.prototype, "raw_would_rather_crops", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
    // eslint-disable-next-line camelcase
], ProposalsView.prototype, "map_config", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ProposalsView.prototype, "raw_user", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: { current_page: 0, proposals: [] } })
], ProposalsView.prototype, "raw_initial_proposals", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('toastSubclient')
], ProposalsView.prototype, "isVisibleToast", null);
ProposalsView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            StandardTemplate: bmk_ui_framework_1.StandardTemplate,
            SidebarTracking: SidebarTracking_vue_1.default,
            TopbarTracking: TopbarTracking_vue_1.default,
            ProposalDetailYield: ProposalDetailYield_vue_1.default,
            ProposalListYield: ProposalListYield_vue_1.default,
            AreaPlaygroundYield: AreaPlaygroundYield_vue_1.default,
            SubclientsSwitcher: SubclientsSwitcher_vue_1.default,
            ModalChangeModule: ModalChangeModule_vue_1.default,
            Toasts: bmk_ui_framework_1.Toasts,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
            ResetGISModal: ResetGISModal_vue_1.default,
        },
    })
], ProposalsView);
exports.default = ProposalsView;
